import { render } from "./ModalZonal.vue?vue&type=template&id=584d2515&scoped=true"
import script from "./ModalZonal.vue?vue&type=script&lang=js"
export * from "./ModalZonal.vue?vue&type=script&lang=js"

import "./ModalZonal.vue?vue&type=style&index=0&id=584d2515&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584d2515"]])

export default __exports__